export const domainThemes = {
  gamezorix: {
    logo: "img/gamezorix_logo.svg",
    color: "#ff9b00",
    productName: "Gamezorix",
    buttonColor: "#ff9b00",
  },
  playnixzone: {
    logo: "img/playnixzone_logo.png",
    productName: "playnixzone",
  },
  appspool: {
    logo: "/img/logo-appspool.png",
    productName: "Appspool",
  },
  thegamingclubs: {
    logo: "/img/gamingclub_logo.svg",
    productName: "GamingClubs",
  },
  gamezclan: {
    logo: "img/logo-gamezclan.png",
    productName: "Gamezclan",
  },
  gameflares: {
    logo: "img/gameflares-white.svg",
    color: "#FF394B",
    productName: "Gameflares",
    buttonColor: "#FF394B",
  },
  gamiway: {
    logo: "img/gamiway/gamiway.png",
    color: "#b347a0",
    productName: "Gamiway",
    buttonColor: "#b347a0",
  },
  vplay: {
    logo: "img/VPlay_Logo.svg",
  },
  "gameverse-lt": {
    logo: "img/GameVerse_Logo.svg",
    color: "green",
    productName: "Gameverse",
  },
  funzarena: {
    logo: "img/Funzarena_Logo.svg",
    productName: "funzarena",
  },
  mobbfun: {
    logo: "img/logo-mobbfun.png",
    productName: "Mobbfun",
    color: "green",
  },
  gamiclub: {
    logo: "img/logo-gamiclub.png",
    productName: "Gamiclub",
    color: "green",
  },
  beemobi: {
    logo: "img/logo-beemobi.png",
    productName: "Beemobi",
    color: "green",
  },
  "gami-hub": {
    logo: "img/Gamihub_logo.svg",
    productName: "GamiHub",
    color: "green",
  },
  gamesqueens: {
    logo: "img/gamegueens-logo.svg",
    productName: "gamegueens",
  },
};



// WEBPACK FOOTER //
// ./src/constants/theme.js